import React from 'react';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

import classNames from '../pdf.module.scss';

import * as models from '../../../../utils/models';
import * as data from '../../../../utils/data';

interface VISummarySheetProps extends models.VIReportSummaryData {
	data: models.VIReportItem[];
}

const VISummarySheet: React.FC<VISummarySheetProps> = (props) => {
	return (
		<div className={classNames['visual-inspection']}>
			<div className={classNames['visual-inspection-body']}>
				<div className={classNames['visual-inspection-body-header']}>
					Summary
				</div>
				<div className={classNames['visual-inspection-body-body']}>
					{props.summary}
				</div>
			</div>
			<div className={classNames['visual-inspection-body']}>
				<div className={classNames['visual-inspection-body-header-danger']}>
					Remarks & Recommendations / Actions Taken:
				</div>
				<div className={classNames['visual-inspection-body-body']}>
					<ol>
						{props.remarks.map((remark: string) => (
							<li key={remark}>{remark}</li>
						))}
					</ol>
				</div>
			</div>

			<div className="border-horizontal-light">
				<PDFTablePage columns={data.getVITableColumns()} data={props.data} />
			</div>
		</div>
	);
};

export default VISummarySheet;
